import React from "react";

export default function AcknowledgementsPage() {
  const misericordia = [
    "Alyssa Robinson",
    "Ashley Pitz",
    "Ava Venuto",
    "Brittany Mooney",
    "Brooke Penrod",
    "Faith Foster",
    "Maria Monteleone",
    "Megan Aaron",
    "Megan Fenstermaker",
    "Megan Roman",
    "Samantha Delmar",
  ];

  const proEd5 = [
    { role: "Executive Editor, Books and Materials", name: "Kathy Synatschk" },
    { role: "Senior Editor, Books and Materials", name: "Beth Rowan" },
    { role: "Art Director", name: "Jason Crosier" },
    { role: "Copy Editor", name: "Courtney Bain" },
  ];

  const proEd6 = [
    { role: "Head of Development and Production", name: "Becky Shore" },
    { role: "Senior Editor, Development and Production", name: "Beth Rowan" },
    { role: "Art Director", name: "Jason Crosier" },
  ];

  const otherLinks = [
    { label: "About the Praxis SLP – ETS", href: "#" },
    { label: "YouTube Video – Tips to Pass the Praxis SLP", href: "https://www.youtube.com" },
    { label: "Question of the Day", href: "#" },
    { label: "References", href: "#" },
  ];

  return (
    <div className="bg-gray-50 text-gray-900">
      <main className="max-w-4xl mx-auto px-6 py-10">
        <div className="md:flex md:space-x-8">
          <section className="md:flex-1">
            <h2 className="text-2xl font-bold mb-4">Acknowledgments</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
              <article>
                <h3 className="text-lg font-semibold text-blue-600">Misericordia University &nbsp;
                  <a
                    href="https://www.misericordia.edu"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm underline"
                  >
                    (www.misericordia.edu)
                  </a>

                </h3>
                <ul className="mt-3 grid grid-cols-1 gap-1 text-gray-800 list-inside list-disc">
                  {misericordia.map((name) => (
                    <li key={name} className="py-0.5">{name}</li>
                  ))}
                </ul>
              </article>
              <div>
                <article className="mb-8">
                  <h3 className="text-lg font-semibold text-blue-600">PRO-ED, Inc. &nbsp;
                    <a
                      href="https://www.proedinc.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm underline"
                    >
                      (www.proedinc.com)
                    </a>

                  </h3>

                  <div className="mt-3">
                    <h4 className="font-medium text-blue-500">For 5th edition</h4>
                    <ul className="mt-2 space-y-1 text-gray-800">
                      {proEd5.map((p) => (
                        <li key={p.name} className="leading-tight">{p.name}: <span className="text-sm text-gray-600">{p.role}</span></li>
                      ))}
                    </ul>
                  </div>

                  <div className="mt-4">
                    <h4 className="font-medium text-blue-500">For 6th edition</h4>
                    <ul className="mt-2 space-y-1 text-gray-800">
                      {proEd6.map((p) => (
                        <li key={p.name} className="leading-tight">{p.name}: <span className="text-sm text-gray-600">{p.role}</span></li>
                      ))}
                    </ul>
                  </div>
                </article>

                <article>
                  <h4 className="text-lg font-semibold">Development and Support</h4>
                  <p className="mt-2 text-blue-600">Online Productivity Solutions Pvt. Ltd. &nbsp;
                    <a
                      href="https://www.opspl.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm underline"
                    >
                      (www.opspl.com)
                    </a>

                  </p>
                </article>
              </div>
            </div>
          </section>

        </div>
      </main>
    </div>
  );
}
